import { useEffect } from "react";
import { useLocation } from "wouter";

const SITE = "https://directory.drabpe.org";
const LOGO = "https://s3.ca-central-1.amazonaws.com/ehq-production-canada/bd408b58a587072418ebb665db65921b60fc0997/original/1726595405/c0ed96ca28078bf1a5d84a75b26eef67_DRABPE.png?1726595405";
const pageMeta: Record<string, [string, string]> = {
  "/": ["DRABPE Directory | Durham Region Black Business Constellation", "Explore Black-led businesses, professionals, and community organizations across Durham Region, Ontario."],
  "/directory": ["Business Directory | DRABPE", "Search Black-led businesses and services in Durham Region."],
  "/submit": ["List Your Business | DRABPE Directory", "Submit a business to the DRABPE Directory."],
  "/privacy": ["Privacy Policy | DRABPE Directory", "How the DRABPE Directory collects, uses, and protects personal information."],
  "/terms": ["Terms of Use | DRABPE Directory", "Terms for using the DRABPE Directory."],
};

function setMeta(selector: string, name: string, content: string) {
  let el = document.head.querySelector(selector) as HTMLMetaElement | null;
  if (!el) { el = document.createElement("meta"); el.setAttribute(name.includes(":") ? "property" : "name", name); document.head.appendChild(el); }
  el.content = content;
}

export function SiteMeta() {
  const [location] = useLocation();
  useEffect(() => {
    const [title, description] = pageMeta[location] ?? ["DRABPE Directory", "Discover Black-led businesses and community resources in Durham Region."];
    document.title = title;
    setMeta('meta[name="description"]', "description", description);
    setMeta('meta[property="og:title"]', "og:title", title);
    setMeta('meta[property="og:description"]', "og:description", description);
    setMeta('meta[property="og:image"]', "og:image", LOGO);
    let canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = `${SITE}${location}`;
    let schema = document.getElementById("drabpe-structured-data") as HTMLScriptElement | null;
    if (!schema) { schema = document.createElement("script"); schema.id = "drabpe-structured-data"; schema.type = "application/ld+json"; document.head.appendChild(schema); }
    schema.text = JSON.stringify({ "@context": "https://schema.org", "@type": "Organization", name: "DRABPE Directory", url: SITE, logo: LOGO, areaServed: "Durham Region, Ontario", parentOrganization: { "@type": "Organization", name: "Durham Region Association of Black Professionals & Entrepreneurs", url: "https://drabpe.org" } });
  }, [location]);
  return null;
}
